import { render, staticRenderFns } from "./ApprovalAccount.vue?vue&type=template&id=0bd3756c&"
import script from "./ApprovalAccount.vue?vue&type=script&lang=js&"
export * from "./ApprovalAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports